import React, { Component } from "react";

import { Button, Icon } from "app/NativeComponents/common";

/*
import {
} from 'app/NativeActions';
*/

class SelectAllCheck extends Component {
  render() {
    return (
      <Button
        onPress={() => {
          this.props.checkAllLeads(!this.props.selected_all);
        }}
        style={{
          padding: 10,
          height: 25,

          backgroundColor: this.props.colors.background_color,
          borderRightWidth: 1,
          borderRightColor: this.props.colors.border_color,
          borderRightStyle: "solid",

          borderBottomWidth: 1,
          borderBottomColor: this.props.colors.border_color,
          borderBottomStyle: "solid",

          alignItems: "flex-start",
          justifyContent: "center"
        }}
      >
        <Icon
          icon={
            this.props.selected_all
              ? "check-box"
              : this.props.selected_leads.length > 0
              ? "indeterminate-check-box"
              : "check-box-outline-blank"
          }
          size={22}
        />
      </Button>
    );
  }
}

export default SelectAllCheck;
